import React, { ReactNode } from 'react';
import styles from '../NavigationTabs/NavigationTabs.module.scss';
import {
  NavigationTabItem,
  NavigationTabs,
} from 'components/NavigationTabs/NavigationTabs';

export interface PageSubHeaderProps {
  links: {
    path: string;
    name: string;
    count?: number;
    is_active: boolean;
  }[];
  children?: ReactNode;
}

const PageSubHeader = ({ links = [], children }: PageSubHeaderProps) => {
  return (
    <NavigationTabs>
      {links.map((link) => (
        <NavigationTabItem
          key={link.path}
          name={link.name}
          url={link.path}
          active={link.is_active}
          count={link.count}
          countAriaLabel={link.count ? `${link.name} ${link.count}` : undefined}
        />
      ))}

      {children && <div className={styles.secondaryItems}>{children}</div>}
    </NavigationTabs>
  );
};

export default PageSubHeader;
